import { Quote } from "lucide-react";

const quotes = [
  {
    text: "Celesta reduced our travel spend by 18% in the first year and I still get a human on the phone at 3am. That combination is rare.",
    name: "Elena Marchetti",
    role: "CFO, Ardent Industries",
  },
  {
    text: "Our founders fly four cities a week. Itineraries are quiet, transfers are on time, and reporting arrives before finance asks for it.",
    name: "Rahul Sethi",
    role: "Chief of Staff, Northlake Capital",
  },
  {
    text: "We booked a family holiday to Kashmir through Celesta after using them for work travel. Same attention, zero surprises.",
    name: "Marion Lefevre",
    role: "Managing Partner, Halden & Co.",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-gradient-to-br from-[#4A1D96] to-[#2E1065] text-white overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#F97316]/20 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-[#F97316]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14 reveal">
          <span className="uppercase tracking-[0.28em] text-xs text-[#FFB47A] font-semibold">
            Clientele
          </span>
          <h2
            data-testid="testimonials-heading"
            className="mt-4 font-serif text-4xl sm:text-5xl leading-[1.05] text-white"
          >
            Quiet endorsements
            <br />
            <span className="text-[#FFB47A] italic font-medium">
              from loud rooms.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {quotes.map((q, i) => (
            <figure
              key={q.name}
              data-testid={`testimonial-${i}`}
              className="reveal bg-white/5 backdrop-blur-sm border border-white/15 hover:border-[#F97316] transition-colors duration-500 p-8 lg:p-10 flex flex-col"
            >
              <Quote size={28} className="text-[#F97316] mb-6" strokeWidth={1.5} />
              <blockquote className="font-serif text-xl leading-relaxed text-white flex-1">
                “{q.text}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/15">
                <div className="text-white font-semibold">{q.name}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-[#FFB47A]/90 font-medium">
                  {q.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
